import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <g fill={color} fill-rule="evenodd">
        <path
          d="M4.99988174,3 L4.99987984,4 L13.9998808,4.00002491 L13.9998808,3 L4.99988174,3 Z M13.9998808,7.50008583 L13.9998808,8.50008583 L4.99987984,8.50006104 L4.99988174,7.50006104 L13.9998808,7.50008583 Z M13.9998808,12.0000248 L13.9998808,13.0000248 L4.99987984,13.0000248 L4.99988174,12 L13.9998808,12.0000248 Z"
          fill-opacity=".9"
        />
        <path d="M2.01361803 11.6820713L2.92278125 11.6820713 2.92278125 11.9091632 2.40337304 11.9091632 2.40337304 12.5908368 2.92278125 12.5908368 2.92278125 12.8183264 2.01361803 12.8183264 2.01361803 13.5 3.60445481 13.5 3.60445481 11 2.01361803 11z" />
        <path d="M2.01361803 7.18207127L2.80903642 7.18207127 2.01361803 8.31832644 2.01361803 9 3.60445481 9 3.60445481 8.31832644 2.80903642 8.31832644 3.60445481 7.18207127 3.60445481 6.5 2.01361803 6.5z" />
        <path d="M2.44702514 4.5L3.1286987 4.5 3.1286987 2 2 2 2 2.68207127 2.44702514 2.68207127z" />
      </g>
    </svg>
  )
}
const FontH2Icon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontH2Icon
